// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-hover {
  cursor: pointer;
  transition: background-color 0.3s ease;
}

/* If a CRT has an rgb_mod_link */
.card-hover.has-link {
  background-color: #790057; /* a pale green background */
}

.card-hover.has-link:hover {
  background-color: #50003f; /* slightly darker green on hover */
}

/* If a CRT does NOT have an rgb_mod_link */
.card-hover.no-link {
  background-color: #000000; /* light gray background */
}

.card-hover.no-link:hover {
  background-color: #50003f; /* slightly darker gray on hover */
}

/* Custom colors for the ModdableCRTs toggle specifically */
.custom-toggle input:checked + .slider {
  background-color: #28a745; /* green = moddable */
}

.brand-toc-link {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  color: #eeeeee;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.brand-toc-link:hover, .brand-toc-link:focus {
  background-color: #50003f;
  text-decoration: none;
}

.brand-toc-sidebar {
  position: static;
  z-index: 600;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border: 1px solid #505050;
  padding: 1rem;
  background: #1d0017;
}
.brand-toc-title {
  margin-bottom: 1rem;
}
.brand-toc-list {
  overflow-y: visible;
}

[id^="brand-"] {
  scroll-margin-top: 60px;
}


/* View toggle button styles */
.btn-outline-secondary svg {
  vertical-align: middle;
  margin-top: -2px;
  width: 16px;
  height: 16px;
  stroke-width: 0.5;
}

/* List view styles - scoped to our CRT tables */
.crt-table .table {
  table-layout: fixed;
  width: 100%;
}

.crt-table .table tr {
  transition: background-color 0.2s ease;
}

.crt-table .table tr:hover {
  background-color: var(--bs-table-hover-bg);
}

.crt-table .table td {
  vertical-align: middle;
  white-space: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  padding: 0.75rem;
}

/* Table column widths */
.crt-table .table th:nth-child(1),
.crt-table .table td:nth-child(1) {
  width: 25%;  /* Model */
}

.crt-table .table th:nth-child(2),
.crt-table .table td:nth-child(2) {
  width: 25%;  /* Jungle IC */
}

.crt-table .table th:nth-child(3),
.crt-table .table td:nth-child(3) {
  width: 20%;  /* Chassis */
}

.crt-table .table th:nth-child(4),
.crt-table .table td:nth-child(4) {
  width: 20%;  /* Mod Types */
}

.crt-table .table th:nth-child(5),
.crt-table .table td:nth-child(5) {
  width: 10%;  /* Actions */
}

/* Link styling */
.crt-table .table td a {
  color: var(--bs-link-color);
  text-decoration: none;
}

.crt-table .table td a:hover {
  text-decoration: underline;
}

/* Ensure consistent badge styling between views */
.crt-table .badge {
  font-size: 0.75rem;
  padding: 0.35em 0.65em;
}

/* Responsive table adjustments */
@media (max-width: 767px) {
  .crt-table .table {
    table-layout: fixed;
  }
  
  .crt-table .table th:nth-child(1),
  .crt-table .table td:nth-child(1) {
    width: 40%;  /* Model gets more space on mobile */
  }
  
  .crt-table .table th:nth-child(3),
  .crt-table .table td:nth-child(3) {
    width: 40%;  /* Chassis gets remaining space */
  }
  
  .crt-table .table th:nth-child(5),
  .crt-table .table td:nth-child(5) {
    width: 20%;  /* Actions stays compact */
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ModdableCRTs.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;;EAEE,UAAU,GAAG,UAAU;AACzB;;AAEA;;EAEE,UAAU,GAAG,cAAc;AAC7B;;AAEA;;EAEE,UAAU,GAAG,YAAY;AAC3B;;AAEA;;EAEE,UAAU,GAAG,cAAc;AAC7B;;AAEA;;EAEE,UAAU,GAAG,YAAY;AAC3B;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,UAAU,GAAG,oCAAoC;EACnD;;EAEA;;IAEE,UAAU,GAAG,iCAAiC;EAChD;;EAEA;;IAEE,UAAU,GAAG,0BAA0B;EACzC;AACF","sourcesContent":[".card-hover {\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n/* If a CRT has an rgb_mod_link */\n.card-hover.has-link {\n  background-color: #790057; /* a pale green background */\n}\n\n.card-hover.has-link:hover {\n  background-color: #50003f; /* slightly darker green on hover */\n}\n\n/* If a CRT does NOT have an rgb_mod_link */\n.card-hover.no-link {\n  background-color: #000000; /* light gray background */\n}\n\n.card-hover.no-link:hover {\n  background-color: #50003f; /* slightly darker gray on hover */\n}\n\n/* Custom colors for the ModdableCRTs toggle specifically */\n.custom-toggle input:checked + .slider {\n  background-color: #28a745; /* green = moddable */\n}\n\n.brand-toc-link {\n  display: block;\n  width: 100%;\n  padding: 8px 12px;\n  border-radius: 6px;\n  color: #eeeeee;\n  text-decoration: none;\n  transition: background 0.15s, color 0.15s;\n}\n.brand-toc-link:hover, .brand-toc-link:focus {\n  background-color: #50003f;\n  text-decoration: none;\n}\n\n.brand-toc-sidebar {\n  position: static;\n  z-index: 600;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.04);\n  border: 1px solid #505050;\n  padding: 1rem;\n  background: #1d0017;\n}\n.brand-toc-title {\n  margin-bottom: 1rem;\n}\n.brand-toc-list {\n  overflow-y: visible;\n}\n\n[id^=\"brand-\"] {\n  scroll-margin-top: 60px;\n}\n\n\n/* View toggle button styles */\n.btn-outline-secondary svg {\n  vertical-align: middle;\n  margin-top: -2px;\n  width: 16px;\n  height: 16px;\n  stroke-width: 0.5;\n}\n\n/* List view styles - scoped to our CRT tables */\n.crt-table .table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.crt-table .table tr {\n  transition: background-color 0.2s ease;\n}\n\n.crt-table .table tr:hover {\n  background-color: var(--bs-table-hover-bg);\n}\n\n.crt-table .table td {\n  vertical-align: middle;\n  white-space: normal;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  padding: 0.75rem;\n}\n\n/* Table column widths */\n.crt-table .table th:nth-child(1),\n.crt-table .table td:nth-child(1) {\n  width: 25%;  /* Model */\n}\n\n.crt-table .table th:nth-child(2),\n.crt-table .table td:nth-child(2) {\n  width: 25%;  /* Jungle IC */\n}\n\n.crt-table .table th:nth-child(3),\n.crt-table .table td:nth-child(3) {\n  width: 20%;  /* Chassis */\n}\n\n.crt-table .table th:nth-child(4),\n.crt-table .table td:nth-child(4) {\n  width: 20%;  /* Mod Types */\n}\n\n.crt-table .table th:nth-child(5),\n.crt-table .table td:nth-child(5) {\n  width: 10%;  /* Actions */\n}\n\n/* Link styling */\n.crt-table .table td a {\n  color: var(--bs-link-color);\n  text-decoration: none;\n}\n\n.crt-table .table td a:hover {\n  text-decoration: underline;\n}\n\n/* Ensure consistent badge styling between views */\n.crt-table .badge {\n  font-size: 0.75rem;\n  padding: 0.35em 0.65em;\n}\n\n/* Responsive table adjustments */\n@media (max-width: 767px) {\n  .crt-table .table {\n    table-layout: fixed;\n  }\n  \n  .crt-table .table th:nth-child(1),\n  .crt-table .table td:nth-child(1) {\n    width: 40%;  /* Model gets more space on mobile */\n  }\n  \n  .crt-table .table th:nth-child(3),\n  .crt-table .table td:nth-child(3) {\n    width: 40%;  /* Chassis gets remaining space */\n  }\n  \n  .crt-table .table th:nth-child(5),\n  .crt-table .table td:nth-child(5) {\n    width: 20%;  /* Actions stays compact */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
